import { render, staticRenderFns } from "./cookie-consent-button.vue?vue&type=template&id=55a76599&"
import script from "./cookie-consent-button.vue?vue&type=script&lang=js&"
export * from "./cookie-consent-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports